import { Tabs } from 'antd';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import PPPageHeader from '../../components/pageHeader/PPPageHeader';
import BranchesTab from './BranchesTab';
import BrandTab from './BrandTab';
import ContractTab from './ContractTab';
import InformationTab from './InformationTab';
import UserTab from './UserTab';
import './profilepage.less';

const ALL_TABS = [
  { key: 'info', label: 'Бүртгэлийн мэдээлэл' },
  { key: 'branch', label: 'Салбарууд' },
  { key: 'contract', label: 'Гэрээ, баримт' },
  { key: 'user', label: 'Ажилтан' },
  { key: 'brand', label: 'Брэнд' },
];

const ProfilePage = () => {
  const history = useHistory();
  const location = useLocation();

  const initialTab = new URLSearchParams(location.search).get('tab') || ALL_TABS[0].key;
  const getValidKey = (key) => (ALL_TABS.find((item) => item.key === key) ? key : ALL_TABS[0].key);

  const [currentKey, setCurrentKey] = useState(() => getValidKey(initialTab));

  const onChange = (key) => {
    setCurrentKey(key);
    history.replace({
      pathname: '/settings',
      search: `?tab=${key}`,
      state: location.state,
    });
  };

  return (
    <div>
      <PPPageHeader title="Тохиргоо" />
      <Tabs
        activeKey={currentKey}
        onChange={onChange}
        items={ALL_TABS}
        tabBarStyle={{ marginBottom: 0, margin: '0', padding: '0 12px' }}
      />

      {/* Эдгээр таб өөрсдөө эргэн тойрны зайгаа агуулсан тул wrapper-гүй */}
      {currentKey === 'info' && <InformationTab />}
      {currentKey === 'branch' && <BranchesTab />}
      {currentKey === 'contract' && <ContractTab />}
      {currentKey === 'user' && <UserTab />}
      {currentKey === 'brand' && <BrandTab />}
    </div>
  );
};

export default ProfilePage;
